module.exports = __webpack_public_path__ + "static/media/buy.94cc3c0a.jpg";